import axios from "axios";
import moment from "moment";
import {orderBy} from "lodash";
import {isOneDaySelected} from "./dateHelpers";

const getData = async (date, symbol, symbolIndex) => {
  let respAmRest;
  let respIndex;

  if (isOneDaySelected(date)) {
    respAmRest = await _fetchDataFromSingleDay(symbol, date.begin);
    respIndex = await _fetchDataFromSingleDay(symbolIndex, date.begin);
  } else {
    respAmRest = await _fetchDataFromPeriod(symbol, date);
    respIndex = await _fetchDataFromPeriod(symbolIndex, date);
  }

  return {
    amrest: respAmRest,
    index: respIndex,
    currency: await _fetchCurrencyBySymbol(symbol)
  };
};

const _fetchDataFromPeriod = async (symbol, date) => {

  const language = drupalSettings.path.currentLanguage || '';
  try {
    let resp = await axios.get(
      `/` + language + `/api/market/${symbol}/day?from=${date.begin}&to=${date.end}`
    );

    resp = resp.data.map(({date, price_close, volume, price_open, price_high, price_low}) => ({
      date: moment(date).toDate(),
      value: price_close,
      volume: volume,
      open: price_open,
      close: price_close,
      high: price_high,
      low: price_low
    }));
    resp = orderBy(resp, item => moment(item.date).format("YYYYMMDD"), ["asc"]);

    return resp;
  } catch (e) {
    console.log(e.response);
    return e.response.data.message;
  }
};

const _fetchDataFromSingleDay = async (symbol, day) => {

  const language = drupalSettings.path.currentLanguage || '';
  try {
    let resp = await axios.get(
      `/` + language + `/api/market/${symbol}/intraday?date=${day}`
    );

    resp = resp.data.map(({time, price, volume}) => ({
      date: moment(day).hour(time.split(':')[0]).minute(time.split(':')[1]).toDate(),
      value: price,
      volume: volume
    }));

    return resp;
  } catch (e) {
    console.log(e.response);
    return e.response.data.message;
  }
};

const _fetchCurrencyBySymbol = async(symbol) => {

  const language = drupalSettings.path.currentLanguage || '';
  try {
    let resp = await axios.get(
      `/` + language + `/api/market/${symbol}`
    );

    return resp.data.currency;
  } catch (e) {
    console.log(e.response);
    return e.response.data.message;
  }
}

export default getData;
